export enum EventSubscriptionType {
  BACK_IN_STOCK = 'BACK_IN_STOCK',
}
